import { clsx } from 'clsx'
import { type FC } from 'react'

import { type OfferV11 } from '@redteclab/api/clients/bully'
import { IconInfo } from '@redteclab/icons'

import { useGetExperiment } from '../../../../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION } from '../../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../../experiments/model/EXPERIMENT_VARIATION'
import { useOpenableControls } from '../../../../../../generic-hooks'
import { productAccessorGetSellerPromotionFromOffer } from '../../../../../model/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { ProductPageSellerPromotionModal } from '../../../../../ProductPageSellerPromotionModal/ProductPageSellerPromotionModal'
import { useProductPageContext } from '../../../../productPageContext'
import { ProductSellerPromotionFlag } from '../../../../ProductSellerPromotionFlag/ProductSellerPromotionFlag'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'

type ProductHeadSellerPromotionLabelProps = {
  className?: string
  offer: OfferV11 | undefined
}

export const ProductHeadSellerPromotionLabel: FC<
  ProductHeadSellerPromotionLabelProps
> = ({ className, offer }) => {
  const { product } = useProductPageContext()
  const isMarketplaceHarmonisationExperimentEnabled =
    useGetExperiment(EXPERIMENT_NAME_MARKETPLACE_HARMONISATION).variant ===
    EXPERIMENT_VARIATION.V1

  const { handleClose, handleOpen, isOpen } = useOpenableControls()

  if (!offer) {
    return null
  }

  const sellerPromotion = productAccessorGetSellerPromotionFromOffer(offer)

  if (!sellerPromotion) {
    return null
  }

  return (
    <>
      <ProductHeadGenericLabel
        className={clsx(
          'border-light-primary-strong',
          isMarketplaceHarmonisationExperimentEnabled
            ? 'gap-1 bg-light-tertiary'
            : 'bg-light-brand-medium',
          className,
        )}
        data-qa-id="product-label-seller-promotion"
        onClick={() => {
          if (isMarketplaceHarmonisationExperimentEnabled) {
            handleOpen()
          }
        }}
      >
        <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        {isMarketplaceHarmonisationExperimentEnabled ? (
          <IconInfo className="ml-1 size-4 shrink-0" />
        ) : null}
      </ProductHeadGenericLabel>
      {isMarketplaceHarmonisationExperimentEnabled ? (
        <ProductPageSellerPromotionModal
          dialogTitle={
            <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
          }
          isOpen={isOpen}
          offer={offer}
          onClose={handleClose}
          product={product}
        />
      ) : null}
    </>
  )
}
